import React from 'react'
import { Box, Container, Grid, Typography } from '@material-ui/core'
import Image from 'components/image'
import Button from 'baby-ui/foundation/Button'
import Link from 'baby-ui/foundation/Link/Link'
import useStyles from './FreeGiftHeroSection.styles'

export interface FreeGiftHeroSectionProps {
  onButtonClick: (e: React.MouseEvent<HTMLButtonElement>) => void
  onLinkClick: (
    e:
      | React.MouseEvent<HTMLAnchorElement, MouseEvent>
      | React.MouseEvent<HTMLSpanElement, MouseEvent>
  ) => void
}

const FreeGiftHeroSection = ({
  onButtonClick,
  onLinkClick,
}: FreeGiftHeroSectionProps) => {
  const classes = useStyles()

  return (
    <Container className={classes.milkBagHeroContentContainer}>
      <Grid container alignItems="center" id="free-gift-banner" spacing={2}>
        <Grid item sm={6} xs={12}>
          <Image
            src="//images.babylist.com/image/upload/v1694196139/DME/milk-bag-hero.png"
            style={{ width: '100%' }}
          />
        </Grid>
        <Grid item sm={6} xs={12}>
          <div className={classes.milkBagHeroContent}>
            <Typography
              gutterBottom
              className={classes.milkBagHeroContentH4}
              color="primary"
              variant="h4"
            >
              Get a <b>FREE</b> gift,{' '}
              <span className={classes.nowrap}>valued at $19!</span>
            </Typography>
            <Typography gutterBottom style={{ marginBottom: 32 }} variant="h5">
              Receive a set of milk storage bags on us when you order your pump
            </Typography>

            <ul className={classes.milkBagHeroContentList}>
              <Typography className={classes.listItemArcBullet} component="li">
                Set of 120, self-standing Momcozy bags
              </Typography>
              <Typography
                className={classes.listItemTriangleBullet}
                component="li"
              >
                Built-in indicator to ensure a safe serving temperature for baby
              </Typography>
              <Typography
                className={classes.listItemCircleBullet}
                component="li"
              >
                Limited time only
              </Typography>
            </ul>

            <div className={classes.alignCenterOnMobile}>
              <Button
                color="secondary"
                href="#"
                size="large"
                style={{ width: 280 }}
                variant="contained"
                onClick={onButtonClick}
              >
                Get My Free Gift
              </Button>
              <Box paddingY={2}>
                <Link
                  href="#"
                  style={{ textDecoration: 'underline' }}
                  onClick={(e) => {
                    e.preventDefault()
                    onLinkClick(e)
                  }}
                >
                  See details/terms
                </Link>
              </Box>
            </div>
          </div>
        </Grid>
      </Grid>
    </Container>
  )
}

export default FreeGiftHeroSection
